import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {InputDialogComponent, InputDialogData} from '@app/shared/input-dialog/input-dialog.component';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  constructor(private dialog: MatDialog, private translate: TranslateService) {}

  private subheader(nameOfThingToDelete?: string): string {
    let subheader = this.translate.instant('global.are_you_sure_you_want_to_delete');
    subheader += nameOfThingToDelete ? ` "${nameOfThingToDelete}"` : '';
    return subheader + '?';
  }

  deleteConfirmationDialog(nameOfThingToDelete?: string): Observable<string> {
    const data: InputDialogData = {
      message: 'global.delete',
      subheader: this.subheader(nameOfThingToDelete),
      showInput: false,
      okButtonLabel: 'global.delete'
    };
    return this.dialog
      .open(InputDialogComponent, {
        disableClose: true,
        data
      })
      .afterClosed();
  }

  confirmationDialog(title: string, text: string): Observable<boolean> {
    const data: InputDialogData = {
      message: title,
      subheader: text,
      showInput: false,
      okButtonLabel: 'global.yes'
    };
    return this.dialog
      .open(InputDialogComponent, {
        data
      })
      .afterClosed()
      .pipe(map(ok => !!ok));
  }
}
